// turnos.paciente_nombre puede venir en formato "Apellido, Nombre" (turnos nuevos, Política
// de Identificación del Paciente) o, para turnos históricos, en el formato viejo "Nombre
// Apellido". Estas funciones sirven para textos dirigidos al paciente (WhatsApp, pantallas
// de éxito, saludos) donde siempre se quiere el orden natural, sin importar el origen.

export function primerNombrePaciente(pacienteNombre) {
  const s = (pacienteNombre || '').trim();
  if (!s) return '';
  const coma = s.indexOf(',');
  if (coma !== -1) return s.slice(coma + 1).trim().split(' ')[0] || '';
  return s.split(' ')[0];
}

export function nombreNaturalPaciente(pacienteNombre) {
  const s = (pacienteNombre || '').trim();
  if (!s) return '';
  const coma = s.indexOf(',');
  if (coma === -1) return s;
  const apellido = s.slice(0, coma).trim();
  const nombre = s.slice(coma + 1).trim();
  return `${nombre} ${apellido}`.trim();
}
